<script>
import NavBar from '@/components/navbar/NavBar'
import SubNavBar from '@/components/navbar/SubNavBar'
import FooterView from '@/components/Footer'
export default {
  name: 'app',
  components: {
    NavBar,
    SubNavBar,
    FooterView,
  },
}
</script>
<template>
  <div id="app">
    <nav-bar/>
    <sub-nav-bar/>
    <div class="separator_thin"></div>
    <!-- <div class="header-discount">
      <img src="@/assets/images/common/price-tag.png" width="25px" height="25px"/>
      <span style="margin-left: 0.5em;margin-right: 0.5em;">
        Sconto del 20% su tutti i kayak presenti in negozio in pronta consegna
      </span>
      <img src="@/assets/images/common/price-tag.png" width="25px" height="25px"/>
    </div> -->
    <div class="separator_thin"></div>
    <router-view/>
    <footer-view/>
  </div>
</template>